import React from "react";
import {FIELD_TYPE, FORMAT_TIME, tabKeys} from "types/enums";
import {ColumnsType} from "antd/es/table";
import {ColumnProps} from "types/models";
import moment from "moment";
import dayjs from "dayjs";

// import DilateStatusCard from "./DilateStatusCard/DilateStatusCard";
import {listGender} from "data/list";
import {DataFormField} from "types/models/input-field-type";
import {gioiTinhOptions} from "assets/constants/select-catagory-options";
import {parseDatetime, toDateTime} from "helper/format-date";
const {INPUT, SELECT, DATE, NUMBER} = FIELD_TYPE;

const bedColumns: ColumnProps[] = [
  {
    title: "STT",
    dataIndex: "stt",
    show: true,
    render: (v, r, i) => i + 1,
    align: "center",
  },
  {
    title: "Mã giường",
    dataIndex: "maGiuong",
    align: "left",
    show: true,
  },
  {
    title: "Số giường",
    dataIndex: "soGiuong",
    align: "left",
    show: true,
  },
  {
    title: "Phòng/buồng",
    dataIndex: "tenBuongPhong",
    align: "left",
    show: true,
  },
  {
    title: "Dịch vụ",
    dataIndex: "dichVuGiuong",
    align: "left",
    show: true,
  },
  {
    title: "Giá",
    dataIndex: "giaGiuong",
    align: "left",
    show: true,
  },
  {
    title: "BH chi trả",
    dataIndex: "baoHiemChiTra",
    align: "left",
    show: true,
  },
  {
    title: "Thao tác",
    dataIndex: "action",
    show: true,
    align: "center",
    width: "6%",
  },
];
const roomColumns: ColumnProps[] = [
  {
    title: "STT",
    dataIndex: "stt",
    show: true,
    render: (v, r, i) => i + 1,
  },
  {
    title: "Mã phòng",
    dataIndex: "maPhong",
    align: "left",
    show: true,
  },
  {
    title: "Tên phòng",
    dataIndex: "tenPhong",
    align: "left",
    show: true,
  },
  {
    title: "Mô tả",
    dataIndex: "moTa",
    align: "left",
    show: true,
  },
  {
    title: "Thao tác",
    dataIndex: "action",
    show: true,
    align: "center",
    width: "4%",
  },
];

export {bedColumns, roomColumns};
